import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { useEmbedded } from 'hooks/useEmbedded';

import BottomNavigation from 'components/@navigation/BottomNavigation';
import DesktopNavigation from 'components/@navigation/DesktopNavigation';
import Footer from 'components/@navigation/Footer';

interface Props {
  children: ReactNode;
  hideFooterOnMobile?: boolean;
  hideBottomNavigation?: boolean;
}

const AppNavigation = ({
  hideFooterOnMobile,
  hideBottomNavigation,
  children,
}: Props) => {
  const { isEmbedded } = useEmbedded();

  if (isEmbedded) {
    return <>{children}</>;
  }

  return (
    <>
      <DesktopNavigation />
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
      <Box
        sx={{
          display: { xs: hideFooterOnMobile ? 'none' : 'block', md: 'block' },
        }}
      >
        <Footer />
      </Box>
      {!hideBottomNavigation && <BottomNavigation />}
    </>
  );
};

export default AppNavigation;
